import { AfterViewInit, Component, OnInit } from '@angular/core';
import {Location} from '@angular/common';
import Map from 'ol/Map';
import Feature from 'ol/Feature';
import View from 'ol/View';
import {Point,Polygon,MultiPolygon} from 'ol/geom';
import {Style,Fill, Stroke} from 'ol/style';
import Icon from 'ol/style/Icon';
import OSM from 'ol/source/OSM';
import WMTS from 'ol/source/WMTS';
import WMTSTileGrid from 'ol/tilegrid/WMTS';
import Overlay from 'ol/Overlay';
import VectorSource from 'ol/source/Vector';
import GeoJSON from 'ol/format/GeoJSON';
import * as shpwrite from '@aleffabricio/shp-write';
import {Tile as TileLayer, Vector as VectorLayer, Group as LayerGroup} from 'ol/layer';
import * as olExtent from 'ol/extent';
import * as olProj from 'ol/proj';
import LayerSwitcher from 'ol-layerswitcher';
import { BaseLayerOptions, GroupLayerOptions } from 'ol-layerswitcher';
import Attribution from 'ol/control/Attribution';
import { Field, ReportsService } from '../../apiclient';
import { UserSessionService } from '../../UserSession/user-session.service';

import { NbToastrService } from '@nebular/theme';
import { EditableCustomForm } from '../../apiclient/model/editableCustomForm';
import { features } from 'process';


/**
 * Componente que renderiza el Visor de informes en Mapa
 */
@Component({
  selector: 'ngx-visor-informe-mapa',
  templateUrl: './visor-informe-mapa.component.html',
  styleUrls: ['./visor-informe-mapa.component.scss']
})
export class VisorInformeMapaComponent implements OnInit,AfterViewInit {

  tipoInformeSeleccionado: any[] = [];
  fechasFiltro: any;
  tiposInforme = [
    {'title':'Mantenimientos','value':'maintenances'},
    {'title':'Plagas y Enfermedades','value':'diseases'},
    {'title':'Muestreos','value':'sampling'},
  ];

  tiposInformeTitulo = {
    'maintenance': 'Mantenimiento',
    'disease': 'Enfermedad/Plaga',
    'sampling': 'Muestreo',
  }

  fields: any[];
  parcelasToDownload: Field[];
  listaMuestreos: any[];
  muestreoSeleccionado:any;
  informesToDowmload: any[];
  config: any;
  map: Map;
  feature: Feature;
  geometrySource: VectorSource;
  markersGeometrySource: VectorSource;
  markersVectorSource: VectorSource;
  parcelasSource: VectorSource;
  markersParcelasSource: VectorSource;

  featureoriginal: Feature;
  loading: boolean = false;
  informeSeleccionado: any;
  parcelaSeleccionada: any;
  customforms: EditableCustomForm[];

  historicoFiltro = [];  //Esther 29/01/2022
  settings = {};  //Esther EV2022-02
  selectedItems = [];  //Esther EV2022-02

  parcelaStyle =  new Style({
    stroke: new Stroke({
      color: 'blue',
      width: 1,
    }),
    fill: new Fill({
      color: 'rgba(0, 0, 255, 0.1)',
    }),
  });
  iconStyles = {
    'disease': new Style({
      image: new Icon({
        color: '#FF0000',
        crossOrigin: 'anonymous',
        src: 'assets/images/marker_disease.png',
        scale: 0.5,
      }),
      stroke: new Stroke({
        color: '#FF0000',
        width: 2,
      }),
      fill: new Fill({
        color: 'rgba(255, 0, 0, 0.4)',
      }),
    }),
    'maintenance' : new Style({
      image: new Icon({
        color: '#F2EA00',
        crossOrigin: 'anonymous',
        src: 'assets/images/marker_maintenance.png',
        scale: 0.5,
      }),
      stroke: new Stroke({
        color: '#F2EA00',
        width: 2,
      }),
      fill: new Fill({
        color: 'rgba(50, 205, 50, 0.4)',
      }),
    }),
    'sampling' : new Style({
      image: new Icon({
        color: '#00F2E2',
        crossOrigin: 'anonymous',
        src: 'assets/images/marker_sampling.png',
        scale: 0.5,
      }),
      stroke: new Stroke({
        color: '#00F2E2',
        width: 2,
      }),
      fill: new Fill({
        color: 'rgba(50, 205, 50, 0.4)',
      }),
    }),
    'field' : new Style({
      image: new Icon({
        color: '#32CD32',
        crossOrigin: 'anonymous',
        src: 'assets/images/marker_field.png',
        scale: 0.5,
      }),
      stroke: new Stroke({
        color: '#32CD32',
        width: 2,
      }),
      fill: new Fill({
        color: 'rgba(50, 205, 50, 0.1)',
      }),
    }),
  }
  constructor(private location: Location, private reportsService: ReportsService,
    private userSessionService: UserSessionService,
    private toastrService: NbToastrService) { }

    /**
     * @ignore
     */
  ngOnInit(): void {

    this.settings = {
      text: "Tipo de Muestreo",
      selectAllText: 'Select All',
      unSelectAllText: 'UnSelect All',
      labelKey:"form_name",
      searchPlaceholderText:"Buscar",
      singleSelection: true,
      enableSearchFilter: true,
    };  //Esther EV2022-02

    if (typeof this.config === 'undefined') {

      this.config = {
        target: 'visormap',
        center : [-5.6954768,40.9670626]
      };


      this.toastrService.info('Es necesario aplicar filtros para visualizar datos en el mapa','No Hay datos',{duration:5000})

}

    this.userSessionService.getCachedSamplingList().subscribe((muestreos) => {
      this.listaMuestreos = muestreos;
      this.listaMuestreos.sort((a,b)=>a.form_name.toLowerCase() < b.form_name.toLowerCase() ? -1 : 1);  //Esther EV2022-02
      console.log(this.listaMuestreos)
    })
  }

  /**
   * Pinta las geometrías en el mapa
   */
  pintarParcelas() {




    this.fields.forEach((field) => {



      if(field.geometry != null) {
        var feature;
        if( field.geometry.type == 'Polygon'){
          console.log('Polygon')
          field.geometry.coordinates[0] = field.geometry.coordinates[0].map(function(coordinate){
            return olProj.fromLonLat(coordinate);
          })
          console.log(field.geometry.coordinates)
          feature = new Feature({
            geometry: new Polygon(
              field.geometry.coordinates),

            parcela: {name:field.name,region:field.attributes.find( a => a.id == 'region').value},
          });

        }else if(field.geometry.type == 'MultiPolygon'){
          console.log('MultiPolygon')
          field.geometry.coordinates = field.geometry.coordinates.map(coordinates_0 => {
            return coordinates_0.map(coordinate_1 => {
              return coordinate_1.map(coordinate_2 => {
                return olProj.fromLonLat(coordinate_2);
              })
            })
          })

          console.log(field.geometry.coordinates)
          feature = new Feature({
            geometry: new MultiPolygon(
              field.geometry.coordinates),

            pparcela: {name:field.name,region:field.attributes.find( a => a.id == 'region').value},
          });
        }



        feature.setStyle(this.parcelaStyle);
        this.parcelasSource.addFeature(feature);

        //Añadimos el marcador de parcela

        var centro = olExtent.getCenter(feature.getGeometry().getExtent())
        var iconFeature = new Feature({
          geometry: new Point(
            centro),
          tipo: 'field',
          parcela: {name:field.name,region:field.region},
        });

        iconFeature.setStyle(this.iconStyles['field'])
        this.markersParcelasSource.addFeature(iconFeature)


      }




    });


    this.map.getView().fit(this.parcelasSource.getExtent(),{padding:[100,100,100,100],nearest:true});
  }

  /**
   * @ignore
   */
  ngAfterViewInit(): void {
    this.initMap();
    this.userSessionService.getCachedFieldList().subscribe((fields) => {
      console.log(fields)
      this.parcelasToDownload = JSON.parse(JSON.stringify(fields));
      this.fields = JSON.parse(JSON.stringify(fields));
      console.log(this.fields)
      this.pintarParcelas();
    })
  }

  /**
   * Regresa a la página anterior
   */
   back(): void{
    var objFiltro: any = new Object();
    if (this.historicoFiltro !== undefined){
      objFiltro = this.historicoFiltro.pop();
      if (objFiltro !== undefined){
        if (objFiltro.tipoInformeSeleccionado === this.tipoInformeSeleccionado && objFiltro.fechasFiltro === this.fechasFiltro && objFiltro.muestreoSeleccionado === this.muestreoSeleccionado){
          objFiltro = this.historicoFiltro.pop();
        }
        if (objFiltro !== undefined){
          this.tipoInformeSeleccionado = objFiltro.tipoInformeSeleccionado;
          this.fechasFiltro = objFiltro.fechasFiltro;
          this.muestreoSeleccionado = objFiltro.muestreoSeleccionado;
          this.cargarVisor();
        }else{
          this.limpiar();
        }
      }else{
        this.limpiar();
      }
    }
    //this.location.back()  //Esther 29/01/2022
  }

  /**
   * Aplica el filtro informado por el usuario
   */
  aplicar(): void{
    this.cargarVisor();  //Esther 29/01/2022
    this.guardarFiltro();  //Esther 29/01/2022
  }

  /**
  * Guarda los valores elegidos en el filtro  //Esther 29/01/2022
  */
 guardarFiltro (): void{
  this.historicoFiltro.push({tipoInformeSeleccionado:this.tipoInformeSeleccionado, fechasFiltro:this.fechasFiltro, muestreoSeleccionado:this.muestreoSeleccionado});
}

  /**
  * Carga el visor de cada uno de los posibles informes  //Esther 29/01/2022
  */
   cargarVisor (): void{
   // this.tipoInformeSeleccionado.sort((a,b)=>a.name.toLowerCase() < b.name.toLowerCase() ? -1 : 1);  //Esther EV2022-02
    if(this.tipoInformeSeleccionado.length > 0){
      this.geometrySource.clear();
      this.markersGeometrySource.clear();
      this.markersVectorSource.clear();
      this.tipoInformeSeleccionado.forEach((informe) => {
          switch(informe){
          case 'diseases':
            this.obtenerInformesEnfermedades();
            break;
          case 'maintenances':
            this.obtenerInformesMantenimientos();
            break;
          case 'sampling':
            this.obtenerInformesMuestreos();
          break;

        }
      })
    }else{
      this.toastrService.warning('Debe seleccionar un tipo de informe','Tipo de Informe')
    }
}

  /**
   * Obtiene los reportes de tipo Plaga
   */
  obtenerInformesEnfermedades(){
    this.loading = true;
    let inicio = null;
    let fin = null;
    if(this.fechasFiltro != null){
      inicio=this.fechasFiltro.start;
      fin = this.fechasFiltro.end;
    }
    this.reportsService.diseasereportlist(-1,this.userSessionService.accessToken,inicio,fin,null,null)
    .subscribe((informes) => {
        console.log(informes);
        if(typeof informes.entities != undefined && informes.entities != null){
          this.loading = false;
          if(informes.entities.length > 0){
            this.pintarMarcadores(informes.entities,'disease');
            var extent = olExtent.createEmpty();
            olExtent.extend(extent, this.markersVectorSource.getExtent());
            olExtent.extend(extent, this.markersGeometrySource.getExtent());
            this.map.getView().fit(extent,{padding:[100,100,100,100],nearest:true});

          }else{
            this.toastrService.warning('No se han encontrado informes que cumplan los criterios de búsqueda','No hay datos')
          }


        }

    })
  }

  /**
   * Obtiene los reportes de tipo Muestreo
   */
  obtenerInformesMuestreos(){
    this.loading = true;
    let inicio = null;
    let fin = null;
    if(this.fechasFiltro != null){
      inicio=this.fechasFiltro.start;
      fin = this.fechasFiltro.end;
    }
    //this.muestreoSeleccionado.sort((a,b)=>a.name.toLowerCase() < b.name.toLowerCase() ? -1 : 1);  //Esther EV2022-02
    var idMuestreo;
    if(this.muestreoSeleccionado != undefined && this.muestreoSeleccionado.length > 0){
      idMuestreo = this.muestreoSeleccionado[0].id
    }
    this.reportsService.customreportlist(-1,this.userSessionService.accessToken,inicio,fin,null,null,'sampling',idMuestreo)
    .subscribe((informes) => {

        if(typeof informes.entities != undefined && informes.entities != null){
          this.loading = false;
          if(informes.entities.length > 0){
            this.pintarMarcadores(informes.entities,'sampling');
            try{
              var extent = olExtent.createEmpty();
            olExtent.extend(extent, this.markersVectorSource.getExtent());
            olExtent.extend(extent, this.markersGeometrySource.getExtent());
              this.map.getView().fit(extent,{padding:[100,100,100,100],nearest:true});
            }catch(e){
              console.log("error al ajustar el mapa")
              console.log(e);
            }
          }else{
            this.toastrService.warning('No se han encontrado informes que cumplan los criterios de búsqueda','No hay datos')
          }


        }

    });
  }

  /**
   * Obtiene los reportes de tipo Mantenimiento
   */
  obtenerInformesMantenimientos(){
    this.loading = true;
    let inicio = null;
    let fin = null;
    if(this.fechasFiltro != null){
      inicio=this.fechasFiltro.start;
      fin = this.fechasFiltro.end;
    }
    this.reportsService.maintenanceportlist(-1,this.userSessionService.accessToken,inicio,fin,null,null)
    .subscribe((informes) => {

        if(typeof informes.entities != undefined && informes.entities != null){
          this.loading = false;
          if(informes.entities.length > 0){
            this.pintarMarcadores(informes.entities,'maintenance');
            var extent = olExtent.createEmpty();
            olExtent.extend(extent, this.markersVectorSource.getExtent());
            olExtent.extend(extent, this.markersGeometrySource.getExtent());
            this.map.getView().fit(extent,{padding:[100,100,100,100],nearest:true});
          }else{
            this.toastrService.warning('No se han encontrado informes que cumplan los criterios de búsqueda','No hay datos')
          }



        }

    });
  }

  /**
   * Pinta los marcadores en el mapa
   * @param informes
   * @param tipo
   */
  pintarMarcadores(informes: any[],tipo){
    let marcadores = [];


    informes.forEach((informe) => {

      console.log("Pintando MARCADORES REPORTES")
      console.log(informe)
      try{
      var coordinates = [];
      var tipogeometria ="";
      if(tipo == 'sampling'){
        coordinates = informe.form_data.location.geometry.coordinates;
        tipogeometria = informe.form_data.location.geometry.type
      }else{
        coordinates = informe.localizacion.coordinates;
        tipogeometria = informe.localizacion.type
      }
      informe.tipo = tipo;
      informe.titulo = this.tiposInformeTitulo[tipo]


      if( tipogeometria == 'Point'){
        var iconFeature = new Feature({
          geometry: new Point(
            olProj.fromLonLat(coordinates)),
          name: informe.diseaseName,
          tipo: tipo,
          informe: informe,
        });



        iconFeature.setStyle(this.iconStyles[tipo]);


        this.markersVectorSource.addFeature(iconFeature);
      }else if (tipogeometria == 'Polygon'){

        var polygoncoordinates = JSON.parse(JSON.stringify(coordinates));
        polygoncoordinates[0] = polygoncoordinates[0].map(function(coordinate){
          return olProj.fromLonLat(coordinate);
        })

        let feature = new Feature({
          geometry: new Polygon(
            polygoncoordinates),
            name: informe.diseaseName,
            tipo: tipo,
            informe: informe,
        });

        feature.setStyle(this.iconStyles[tipo]);


        this.geometrySource.addFeature(feature);

        //Hay que añadir el centro
        var centro = olExtent.getCenter(feature.getGeometry().getExtent())
        var iconFeature = new Feature({
          geometry: new Point(
            centro),
          name: informe.diseaseName,
          tipo: tipo,
          informe: informe,
        });



        iconFeature.setStyle(this.iconStyles[tipo]);


        this.markersGeometrySource.addFeature(iconFeature);

      }



    }catch(error){
      console.log("Error al pintar marcador...");

    }
    });

  }

  /**
   * Limpia el filtro
   */
  limpiar(): void{

    this.tipoInformeSeleccionado = [];
    this.muestreoSeleccionado = null;
    this.fechasFiltro = null;
    this.geometrySource.clear();
    this.markersGeometrySource.clear();
    this.markersVectorSource.clear();
    olProj.get('EPSG:3857').getExtent();
  }

  /**
   * Inicializa el mapa OpenLayers
   */
  initMap() {
    this.geometrySource = new VectorSource();
    this.markersGeometrySource = new VectorSource();
    this.markersVectorSource = new VectorSource();;
    this.markersParcelasSource = new VectorSource();
    this.parcelasSource = new VectorSource();

    const attribution = new Attribution({
      html: 'Teselas de PNOA cedido por � Instituto Geogr�fico Nacional de Espa�a'
    });

    let projection = olProj.get('EPSG:3857');
    let projectionExtent = projection.getExtent();
    //var size = ol.extent.getWidth(projectionExtent) / 512;
    let size = olExtent.getWidth(projectionExtent) / 256;
    let resolutions = new Array(18);
    let matrixIds = new Array(18);
    for (var z = 0; z < 18; ++z) {
      // generate resolutions and matrixIds arrays for this WMTS
      resolutions[z] = size / Math.pow(2, z);
      //matrixIds[z] = "EPSG:4326:" + z;
      matrixIds[z] = z;
    }

    this.map = new Map({
      target: this.config.target,
      layers: [
        new TileLayer(<BaseLayerOptions>{
          source: new OSM(),
          visible:true,
          title: 'Mapa Base',
          type:'base',
        }) ,
        new TileLayer({
          visible: false,
          title: 'Mapa Geográfico',
          type:'base',
          source: new WMTS({
            attributions:
              'Tiles © <a href="https://services.arcgisonline.com/arcgis/rest/' +
              'services/Demographics/USA_Population_Density/MapServer/">ArcGIS</a>',
            url:
              'https://server.arcgisonline.com/arcgis/rest/services/World_Imagery/MapServer/WMTS/',
            layer: '0',
            matrixSet: 'EPSG:3857',
            format: 'image/png',
            projection: projection,
            tileGrid: new WMTSTileGrid({
              origin: olExtent.getTopLeft(olProj.get('EPSG:3857').getExtent()),
              resolutions: resolutions,
              matrixIds: matrixIds,
            }),
            style: 'default',
            wrapX: true,
          }),
        }),
        new LayerGroup({
          visible: true,
          title: 'Parcelas',
          combine:true,
          layers:[
            new VectorLayer({
              title: 'Parcelas Geometria',
              source: this.parcelasSource,
              minZoom:14
            }),
            new VectorLayer({
              title: 'Parcelas Marcadores',
              source: this.markersParcelasSource,
              maxZoom:14
            }),
          ]
        }),
        new VectorLayer({
          source: this.geometrySource,
          minZoom:14
        }),
        new VectorLayer({
          source: this.markersGeometrySource,
          maxZoom:14
        }),
        new VectorLayer({
          source: this.markersVectorSource,
        }),
      ],
      view: new View({
        center: olProj.fromLonLat(this.config.center),
        zoom: 5,
      })
    });

    var layerSwitcher = new LayerSwitcher();
    this.map.addControl(layerSwitcher);

    this.initPopup();

  }

  private initPopup(){


// display popup on click
this.map.on('click',(evt)=> {
  var feature = this.map.forEachFeatureAtPixel(evt.pixel,(feature) => {
    return feature;
  });

  this.informeSeleccionado = null;
  this.parcelaSeleccionada = null;
  if(feature && feature.get('informe') != null){
    this.informeSeleccionado = feature.get('informe')
  }else if(feature && feature.get('parcela') != null){
    this.parcelaSeleccionada = feature.get('parcela');
  }


});

  }

  /**
   * Cierra el reporte en el panel lateral derecho
   */
  closeReport(){
    this.informeSeleccionado = null;
    this.parcelaSeleccionada = null;
  }

  /**
   * Exporta en formato Geojson los reportes cargados en el mapa
   */
exportar(){

  let geojson = {
    "type": "FeatureCollection",
    "features": [],
  }

  this.parcelasToDownload.forEach((parcela) => {
    if(null != parcela.polygon){

      let feature = {
        type:'Feature',
        geometry: parcela.polygon,
        properties: {
          nombre: parcela.name,
          region: parcela.region,
        }

      }

      geojson.features.push(feature)
    }

  })


  //Vamos con los informes de geometria

  let informesjson = JSON.parse(new GeoJSON().writeFeatures(this.geometrySource.getFeatures()));

  informesjson.features.map(function(feature){

    feature.geometry.coordinates = olProj.toLonLat(feature.geometry.coordinates);


    return feature;
  })

  geojson.features = geojson.features.concat(informesjson.features)

  //Vamos con los informes de marcadores

  let marcadoresjson = JSON.parse(new GeoJSON().writeFeatures(this.markersVectorSource.getFeatures()));

  marcadoresjson.features.map(function(feature){

    feature.geometry.coordinates = olProj.toLonLat(feature.geometry.coordinates);


    return feature;
  })

  geojson.features = geojson.features.concat(marcadoresjson.features)

  shpwrite.download(geojson,{
    folder: 'geometrias-smartrural',
    types: {
        point: 'informes',
        polygon: 'parcelas'
    }})
  }

}
